"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchGrantees = exports.createGrantees = exports.getGrantees = void 0;
const headers_1 = require("../utils/headers");
const http_1 = require("../utils/http");
const granteeEndpoint = 'grantee';
async function getGrantees(reference, requestOptions) {
    const response = await (0, http_1.http)(requestOptions, {
        method: 'get',
        url: `${granteeEndpoint}/${reference}`,
        responseType: 'json',
    });
    return {
        status: response.status,
        statusText: response.statusText,
        data: response.data,
    };
}
exports.getGrantees = getGrantees;
async function createGrantees(requestOptions, postageBatchId, grantees) {
    const response = await (0, http_1.http)(requestOptions, {
        method: 'post',
        url: granteeEndpoint,
        data: { grantees },
        headers: {
            ...(0, headers_1.extractRedundantUploadHeaders)(postageBatchId),
        },
        responseType: 'json',
    });
    return {
        status: response.status,
        statusText: response.statusText,
        ref: response.data.ref,
        historyref: response.data.historyref,
    };
}
exports.createGrantees = createGrantees;
async function patchGrantees(postageBatchId, reference, historyRef, grantees, requestOptions) {
    const response = await (0, http_1.http)(requestOptions, {
        method: 'patch',
        url: `${granteeEndpoint}/${reference}`,
        data: grantees,
        headers: {
            ...(0, headers_1.extractRedundantUploadHeaders)(postageBatchId),
            'swarm-act-history-address': historyRef,
        },
        responseType: 'json',
    });
    return {
        status: response.status,
        statusText: response.statusText,
        ref: response.data.ref,
        historyref: response.data.historyref,
    };
}
exports.patchGrantees = patchGrantees;
